import {RECRUITMENT_ORDER} from '../entities/recruitment/constants';
import {useGetRecruitmentList} from '../repositories/recruitmentRepository';

const jstDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Tokyo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const getTodayInJST = (): string => jstDateFormatter.format(new Date());

// 本日（JST）が応募締切日の公開募集件数を取得する
export const useTodayDeadlineRecruitmentCount = (): {count: number} => {
  const date = getTodayInJST();
  const {data} = useGetRecruitmentList({
    entryStart: date,
    entryEnd: date,
    order: RECRUITMENT_ORDER.DEADLINE,
    limit: 1,
    page: 1,
    config: {staleTime: 1000 * 60 * 5},
  });

  const count = data?.ok ? data.value.totalCount : 0;
  return {count};
};
